import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'plainfooterview',
  templateUrl: './plainfooterview.component.html',
  styleUrls: ['./plainfooterview.component.scss']
})

export class  PlainfooterviewComponent implements OnInit {
  
  public Date: Date;

 

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {

    this.Date = new Date();
  }
  

 
 
 


 
}
